import { render } from "./VsRadio.vue?vue&type=template&id=42b93c18"
import script from "./VsRadio.vue?vue&type=script&lang=js"
export * from "./VsRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__